import { RootState } from '../../../applicationStore';
import { ResourceState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getResourceState = (state: RootState): ResourceState =>
  state.resource;

export const getResourceLoader = createSelector(
  getResourceState,
  (state): boolean => state.loading,
);

export const getResourceData = createSelector(
  getResourceState,
  (state): ResourceState['data'] | null => state?.data || null,
);
